/* RendererUtils.js */

"use strict";
const _ = require("lodash");
const BaseScheduleRenderer = require("./BaseScheduleRenderer");

class RendererUtils {
    static createLabelElement(elemName, labelText) {
        let labelElem = document.createElement(elemName);
        labelElem.classList.add("themed-label");
        labelElem.innerText = labelText;
        return labelElem;
    }

    static groupGridRowElements(gridElem, groupName, labelText, ...childElements) {
        if (childElements.length === 1 && _.isArray(childElements[0])) {
            childElements = childElements[0];
        }
        let parts = [];
        if (labelText) {
            let labelElem = RendererUtils.createLabelElement(`${groupName}-label`, labelText);
            gridElem.appendChild(labelElem);
            labelElem.classList.add("inline-element-gl");
            parts.push(labelElem);
        }
        let containerElem = document.createElement(`${groupName}-container`);
        containerElem.classList.add("inline-container-gl");
        gridElem.appendChild(containerElem);
        childElements.forEach((childElement, idx) => {
            if (childElement) {
                if (_.isString(childElement)) {
                    childElement = RendererUtils.createLabelElement(
                        `${groupName}-label-${idx}`,
                        childElement
                    );
                }
                let childNode =
                    childElement instanceof Node ? childElement : childElement.renderer.rootElement;
                childNode.classList.add("inline-element-gl");
                containerElem.appendChild(childNode);
                parts.push(childElement);
            }
        });
        parts.push(containerElem);
        return parts;
    }

    static removeChildElements(parentElem, ...elements) {
        if (elements.length === 1 && _.isArray(elements[0])) {
            elements = elements[0];
        }
        elements.forEach((element) => {
            if (!(element instanceof Node)) {
                if (element.renderer instanceof BaseScheduleRenderer) {
                    RendererUtils.removeChildElements(parentElem, element.renderer.getParts());
                }
                element = element.renderer.rootElement;
            }
            if (element && element.parentElement === parentElem) {
                parentElem.removeChild(element);
            }
        });
    }

    static appendChildElements(parentElem, ...elements) {
        if (elements.length === 1 && _.isArray(elements[0])) {
            elements = elements[0];
        }
        elements.forEach((element) => {
            element = element instanceof Node ? element : element.renderer.rootElement;
            if (element && !parentElem.contains(element)) {
                parentElem.appendChild(element);
            }
        });
    }

    static hideElements(...elements) {
        RendererUtils.setElementsVisibility(false, elements);
    }

    static showElements(...elements) {
        RendererUtils.setElementsVisibility(true, elements);
    }

    static setElementsVisibility(show, ...elements) {
        if (elements.length === 1 && _.isArray(elements[0])) {
            elements = elements[0];
        }
        elements.forEach((element) => {
            element = element instanceof Node ? element : element.renderer.rootElement;
            if (show) {
                element.classList.remove("hidden");
            } else {
                element.classList.add("hidden");
            }
        });
    }
}
module.exports = RendererUtils;
